import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCompanyAudit } from '../../actions/companyActions'

const useFetchingCompanyAudit = (id, page, pageSize) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCompanyAudit(id, true, page, pageSize))
  }, [dispatch, id])
}

export default useFetchingCompanyAudit
